import { ApiNotificationSource } from './ApiNotificationSource'
import type { NotificationSource } from './NotificationSource'

export type { NotificationListener, NotificationSource } from './NotificationSource'
export { InMemoryNotificationSource } from './InMemoryNotificationSource'
export { ApiNotificationSource } from './ApiNotificationSource'

/**
 * Singleton notification source.
 *
 * - Consumed by `NotificationProvider` so the bell UI stays in sync.
 * - Importable from anywhere in the codebase (services, utils,
 *   non-React modules) to push notifications without needing React
 *   context:
 *
 *     import { notifications } from '<...>/services/notifications'
 *     notifications.add({ kind: 'success', title: 'Saved' })
 *
 * Active implementation: `ApiNotificationSource` — REST-backed inbox
 * with Supabase Realtime push for live updates. Persistent notifications
 * are created by the backend (e.g. survey response submissions); local
 * `add()` calls are transient client-side only.
 *
 * Swap to `InMemoryNotificationSource` here for tests or to disable the
 * backend dependency entirely.
 */
export const notifications: NotificationSource = new ApiNotificationSource()
